var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroogShape2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "droog-shape",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 683,
    height: 592,
    viewBox: "0 0 683 592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-571.312-66.637c-65.55-40.612-81.649-167.83-81.5-226.363L-815.041,305.918,96.2,801.313l301.537-216.9c-24.325-38.493-110.907-125.184-262.636-164C-54.556,371.9,49.3,225.749-102.069,83.32S-489.374-15.872-571.312-66.637Z",
    transform: "translate(285.911 11)",
    fill: "#164273"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-droog-shape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 592
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "droog-shape",
    clipPath: "url(#clip-droog-shape)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-bottom-shape",
    transform: "translate(285.911 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-815.041 -293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M-571.312-66.637c-65.55-40.612-81.649-167.83-81.5-226.363L-815.041,305.918,96.2,801.313l301.537-216.9c-24.325-38.493-110.907-125.184-262.636-164C-54.556,371.9,49.3,225.749-102.069,83.32S-489.374-15.872-571.312-66.637Z",
    transform: "translate(815.041 293)",
    fill: "#164273"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 39.279,
    x2: 80.971,
    transform: "translate(-179.382 79.813)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 121.188,
    y1: 29.778,
    transform: "translate(-288.744 90.466)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 130.034,
    y1: 511.729,
    transform: "translate(-172.02 111.476)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 137.68,
    x2: 352.062,
    transform: "translate(-329.473 321.813)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 193.066,
    x2: 29.444,
    transform: "translate(190.145 440.813)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroogShape2);
export default __webpack_public_path__ + "static/media/droog-shape-2.b0308ce6ac4360c2350b593a183fcfda.svg";
export { ForwardRef as ReactComponent };